import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    activeTab: 0,
}

export const phonebookSlice = createSlice({
    name: 'phonebook',
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        clearActiveTab: (state) => {
            console.log('clearActiveTab')
            state.activeTab = 0
        }
    }
})

export const { setActiveTab, clearActiveTab } = phonebookSlice.actions
export default phonebookSlice.reducer
